import type { AppProps } from "next/app";
import Head from "next/head";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";

const KIOSK_THEME = {
  colorScheme: "light" as const,
  primaryColor: "blue",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  headings: { fontWeight: 600 },
  // Kiosk targets ≥48px touch targets (WCAG AA + accessibility).
  spacing: { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 },
  defaultRadius: "md",
};

export default function KioskApp({ Component, pageProps }: AppProps) {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS theme={KIOSK_THEME}>
      <NotificationsProvider position="top-center" zIndex={9999}>
        <Head>
          <title>Medicoach Kiosk</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, user-scalable=no, viewport-fit=cover"
          />
          <meta name="theme-color" content="#002B83" />
          <meta name="application-name" content="Medicoach Kiosk" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
          <meta name="apple-mobile-web-app-title" content="Kiosk" />
          <meta name="mobile-web-app-capable" content="yes" />
          <meta name="format-detection" content="telephone=no" />
          <link rel="manifest" href="/manifest.json" />
          <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
          <link rel="apple-touch-icon" href="/icon.svg" />
          {/* Prevent the browser from auto-pulling-to-refresh on the
              tablet — the kiosk PWA owns the whole viewport. */}
          <style>{`
            html, body { overscroll-behavior: none; touch-action: manipulation; }
            body { margin: 0; background: #f8f9fa; -webkit-font-smoothing: antialiased; }
          `}</style>
        </Head>
        <Component {...pageProps} />
      </NotificationsProvider>
    </MantineProvider>
  );
}
